<!--
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 13:53:26
 * @LastEditTime: 2023-04-19 10:26:06
 * @LastEditors: mdb
-->
<template>
  <ActivityCode :permission="permission" subdomain="lbu" paramCode="zbu_source_channel_lbu" />
</template>

<script setup lang="ts">
import ActivityCode from '@/views/marketing/marketingManage/activityCode/index.vue'

const permission = {
  add: 'lbu_activity_add_btn',
  edit: 'lbu_activity_edit_btn',
  delete: 'lbu_activity_del_btn',
  enable: 'lbu_activity_enable_btn',
  disable: 'lbu_activity_disable_btn',
  qrcode: 'lbu_activity_qrcode_btn',
  card: 'lbu_activity_card_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuActivityCode' }
</script>

<style scoped></style>
